import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {AdminApi} from '../admin-api';
import {Toast} from '../../shared/toast/toast';
import { AppLoaderComponent } from 'app/shared/app-loader/app-loader.component';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';

@Component({
   selector: 'app-add-site',
   templateUrl: './create-site.component.html',
   styleUrls: ['./create-site.component.css']
})
export class CreateSiteComponent implements OnInit {

   @ViewChild('btnSubmit') btnSubmit: MatButton;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   tin: string;
   siteCode: string;
   siteName: string;
   isEdit: boolean = false;

   constructor(private api: AdminApi, public toast: Toast,
               private dialogRef: MatDialogRef<CreateSiteComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
      if(data.siteCode){
         this.siteCode = data.siteCode;
         this.siteName = data.siteName;
         this.isEdit = true;
      }
   }

   ngOnInit(): void {
      this.tin = window.localStorage.getItem('tin');
   }

   submitSite() {
      const data = {};
      data['tin'] = this.tin;
      data['siteName'] = this.siteName.trim();
      data['siteCode'] = this.siteCode;
      this.btnSubmit.disabled = true;
      if (!this.isEdit){
         this.loader.show();
         this.api.createSite(data).subscribe(res => {
            this.toast.success(res);
            this.dialogRef.close(true);
         }, err => {
            this.toast.error(err.message);
            this.btnSubmit.disabled = false;
         }).add(() => this.loader.hide());;
      } else {
         this.api.updateSite(data).subscribe(res => {
            this.toast.success(res);
            this.dialogRef.close(true);
         }, err => {
            this.toast.error(err.message);
            this.btnSubmit.disabled = false;
         });
      }
   }
}
